// ==== FOOTER: Search Form ==== //

;(function($){

  $(function(){
    // Global namespace
    var searchTypeahead = searchTypeahead || {};

    // Global variables
    var $document     = $(document),
        $searchForm   = $('#cases-search-form-1'),
        $searchField  = $('#cases-search-form-input-1'),
        $searchList   = $searchForm.find('.cases-search-form__autocomplete'),
        $searchLoader = $searchForm.find('.cases-search-form__loader');

    searchTypeahead.loader = function() {
      $searchField.on('keyup', function(e) {
        var value = $searchField.val();

        if (e.which != 13) {
          delay(function(){
            searchTypeahead.getAddressList(value);
          }, 400 );
        }
      });

      var delay = (function(){
        var timer = 0;

        return function(callback, ms){
          clearTimeout (timer);
          timer = setTimeout(callback, ms);
        };
      })();

      $searchField.on('keypress', function (e) {
        if (e.which == 13) {
          var value = $searchField.val();
          var elem = $searchList.find('li:not(.cases-search-form__spacer, .cases-search-form__noresult):first');

          if (value.length > 2) {
            $searchField.val(elem.text());
            var link = elem.find('a').attr('href');

            if (typeof link !== 'undefined') {
              window.location.href = link;
            } else if (elem.text().length > 0) {
              $searchForm.submit();
            }
          }

          return false;
        }
      });

      $searchForm.find('button[type="submit"]').on('click', function (e) {
        e.preventDefault();

        var value = $searchField.val();
        var elem = $searchList.find('li:not(.cases-search-form__spacer, .cases-search-form__noresult):first');

        if (value.length > 2) {
          $searchField.val(elem.text());
          var link = elem.find('a').attr('href');

          if (typeof link !== 'undefined') {
            window.location.href = link;
          } else if (elem.text().length > 0) {
            $searchForm.submit();
          }
        }

        return false;
      });
    };

    searchTypeahead.loader();

    searchTypeahead.getAddressList = function(q) {

      if ( q.length > 2 ) {
        $.ajax({
          url: ajax_url,
          global: false,
          type: 'post',
          dataType: 'json',
          data: {
            action: 'get_address_list',
            string: q
          },
          beforeSend: function() {
            $searchLoader.attr('aria-hidden', 'false');
          },
          complete: function() {
            $searchLoader.attr('aria-hidden', 'true');
          }
        })
        .then(function(response) {
          $searchList.empty();
          $searchList.attr('aria-hidden', 'true');

          if(response.length > 0) {
            var groubedByType = groupBy(response, 'type');

            $.each(groubedByType, function(i, val) {
              var sep = '';
              switch (i) {
                case 'region':
                  sep = 'Landsdel';
                  break;
                case 'commune':
                  sep = 'Kommune';
                  break;
                case 'city':
                  sep = 'By';
                  break;
                case 'place':
                  sep = 'Stednavn';
                  break;
                case 'road':
                  sep = 'Vej';
                  break;
                case 'zipcode':
                  sep = 'Postnummer';
                  break;
                case 'address':
                  sep = 'Adresse';
                  break;
                default:
                  sep = '';
              }

              $searchList.append("<li class='cases-search-form__spacer'>" + sep + "</li>");

              val = val.slice(0,6);

              $.each(val, function(index, value) {
                if (typeof value.url !== 'undefined') {
                  $searchList.append("<li id='autoc-" + i + "-" + index + "'><a href='" + value.url + "'>" + value.label + "</a></li>");
                } else {
                  $searchList.append("<li id='autoc-" + i + "-" + index + "'>" + value.label + "</li>");
                  $("#autoc-" + i + "-" + index).bind("click", chooseItem(value));
                }
              });
            });
          } else {
            $searchList.append("<li class='cases-search-form__noresult'>Ingen resultater. Prøv at søge efter noget andet.</li>");
          }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
          console.log(jqXHR.responseText);
        });
      } else {
        $searchList.attr('aria-hidden', 'true').empty();
        $searchLoader.attr('aria-hidden', 'true');
      }

      function chosen(result) {
        $searchField.focus().val(result.label);
        $searchList.attr('aria-hidden', 'true').empty();
        $searchForm.submit();
      }

      function chooseItem(result) {
        return function (e) {
          e.preventDefault();
          chosen(result);
        }
      }

      function groupBy(xs, key) {
        return xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});
      }
    };

  });

}(jQuery));
